import React from 'react';
import { StyleSheet, View, TouchableOpacity } from 'react-native';

import AntDesign from '@expo/vector-icons/AntDesign';

import { PURPLE } from '../constants/Colors';
import { FlexSpacer } from './Spacers';

type Props = {
  onLeftPress: () => void;
  onRightPress: () => void;
};

const BUTTON_HEIGHT = 36;

const SelectionButton = ({
  direction,
  onPress,
}: {
  direction: 'left' | 'right';
  onPress: () => void;
}) => (
  <TouchableOpacity onPress={onPress}>
    <View style={styles.buttonBackground} />
    <AntDesign
      name={direction === 'left' ? 'leftcircle' : 'rightcircle'}
      size={BUTTON_HEIGHT}
      color={PURPLE}
      style={styles.buttonForeground}
    />
  </TouchableOpacity>
);

export default ({ onLeftPress, onRightPress }: Props) => {
  return (
    <View style={styles.container}>
      <SelectionButton direction="left" onPress={onLeftPress} />
      <FlexSpacer />
      <SelectionButton direction="right" onPress={onRightPress} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFillObject,
    flexDirection: 'row',
    alignItems: 'center',
    padding: 10,
  },
  buttonBackground: {
    position: 'absolute',
    top: 2,
    right: 2,
    left: 2,
    bottom: 2,
    backgroundColor: 'white',
    zIndex: -1000,
    borderRadius: (BUTTON_HEIGHT - 4) / 2,
  },
  buttonForeground: {
    shadowRadius: 5,
    borderRadius: BUTTON_HEIGHT / 2,
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.5,
    lineHeight: BUTTON_HEIGHT,
  },
});
